import { makeRequestAction } from './index';

export const getLoanTypes = makeRequestAction('GET_LOAN_TYPES', {
  onSuccess(params, response) {
    return {
      response: {
        ...response,
      },
    };
  },
});
